<template lang="pug">
  .pdp-info-bullets.xs-12
    .bullets.xs-12
      ul.xs-f-small.lg-f-medium.max-at-tweak
        li.xs-12.sm-12.md-6.lg-6.xs-f-small.lg-f-medium.max-at-tweak(v-for="bullet in bullets" v-html="bullet")

</template>

<script>
  export default {
    name: "PdpInfoBullets",
    props: {
      bullets: {
        type: Array,
        required: true
      }
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-info-bullets
    .bullets
      border-top 1px solid color-fog
      padding 1.5em 0

    ul
      padding-left 8%
      list-style disc

      li
        position relative
        display inline-block
        vertical-align top
        padding-left 1.75em
        padding-right 0.75em
        padding-bottom 0.25em

        &:before
          content '\2022'
          position absolute
          top 0
          left 0

  @media mq-tablet
    .pdp-info-bullets
      padding-left 6%
      padding-right 6%
      
      ul
        padding-left 10%
        padding-right 10%

  @media mq-tablet-plus
    .fixed-width-tweak-upper
      padding-left 3%
      padding-right 3%

  @media mq-desktop-plus
    .pdp-info-bullets
      padding 1.5em 0

</style>